import styled, { css } from 'styled-components'
import rainbow from '../assets/gender/rainbow.svg'
import female from '../assets/gender/female.svg'
import male from '../assets/gender/male.svg'
import noAvatar from '../assets/no_avatar.svg'

export interface AppAvatarProps {
	avatar?: string | undefined
	alt: string
	gender?: string
	width?: number
	height?: number
}

const AppAvatar = styled('object').attrs((props: AppAvatarProps) => {
	return {
		alt: props.alt,
		width: props.width || 45,
		height: props.height || 45,
	}
})<AppAvatarProps>`
	${props => {
		let fallbackImg = noAvatar
		let size = 'cover'
		let bgColor = '#afafaf'
		let border = 'none'

		if (props.avatar) {
			fallbackImg = props.avatar
		} else {
			size = 'contain'
			bgColor = '#ebf3f5'

			if (props.gender) {
				border = 'solid 1px #dcddde;'
			}

			if (props.gender === 'male') {
				fallbackImg = male
			}

			if (props.gender === 'female') {
				fallbackImg = female
			}

			if (props.gender === 'other') {
				fallbackImg = rainbow
			}
		}

		return css`
			border-radius: 50%;
			border: ${border};
			position: absolute;
			left: 0;
			object-fit: cover;
			background-color: ${bgColor};
			background-image: url(${fallbackImg});
			background-size: ${size};
			background-repeat: no-repeat;
			background-position: center;
		`
	}}
`

export { AppAvatar }
